 export const api = 'https://sicu-aura-mailer.vercel.app/sendEmail'